/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Error_Max_100Inputs */

const es_co2_signup_error_max_100 = /** @type {(inputs: Signup_Error_Max_100Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo 100 caracteres`)
};

/**

* @param {Signup_Error_Max_100Inputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_error_max_100 = /** @type {((inputs?: Signup_Error_Max_100Inputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Error_Max_100Inputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_error_max_100(inputs)
});